import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { createContext, useContext } from 'react';

// /////////////////////////////////////////////////////////////////////////////

export const ChannelContext =
  createContext<GatewayChannelWithChargePointInfoModel | null>(null);

export const useChannelContext = (): GatewayChannelWithChargePointInfoModel => {
  const context = useContext(ChannelContext);

  if (!context) {
    throw new Error(
      'useChannelContext must be used within ChannelContext.Provider',
    );
  }

  return context;
};

interface ChannelContextProviderProps {
  data: GatewayChannelWithChargePointInfoModel;
  children: React.ReactNode;
}

export const ChannelContextProvider = ({
  data,
  children,
}: ChannelContextProviderProps): React.JSX.Element => {
  return (
    <ChannelContext.Provider value={data}>{children}</ChannelContext.Provider>
  );
};
